import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

const APP_MODES = ['ems', 'usmle', 'msp', 'mcat'] as const;

const IS_VERCEL = __VERCEL__ === '1';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_APP_NAME: z.string(),
    VITE_API_URL: z.string().url(),
    VITE_AI_API_URL: z.string().url(),
    VITE_APP_URL: z.preprocess(
      // This makes Vercel deployments not fail if you don't set VITE_APP_URL
      // It will automatically use the VERCEL_URL if present.
      (str) => str ?? __VERCEL_URL__,
      // VERCEL_URL doesn't include `https` so it cant be validated as a URL
      IS_VERCEL ? z.string() : z.string().url(),
    ),
    VITE_APP: z.enum(APP_MODES),
    VITE_SENTRY_DSN: z.string().url(),
    VITE_SENTRY_PROJECT: z.string(),
    VITE_SENTRY_ORG: z.string(),
    VITE_SENTRY_ENV: z.enum(['production', 'development']),
    VITE_GTM_ID: z.string(),
    VITE_HOTJAR_ID: z.string(),
    VITE_CLARITY_ID: z.string(),
    VITE_PUBLIC_POSTHOG_KEY: z.string(),
    VITE_PUBLIC_POSTHOG_HOST: z.string().url(),
    VITE_PUBLIC_POSTHOG_DISABLED: z.preprocess(
      (val) => val === 'true',
      z.boolean().default(false),
    ),
    VITE_FACEBOOK_PIXEL_ID: z.string(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
